<template>
    <div class="famous-comment-popup">
        <van-popup :value="showPediaCommentMore" position="bottom" @click-overlay="clickPopOverlay">
            <div class="famous-comment-more-list">
                <div class="famous-crl-item" v-if="curCommentMoreFromMe" @click="clickDelete">删除</div>
                <div class="famous-crl-item" v-else @click="clickReport">举报</div>
                <div class="famous-crl-item" @click="clickCopy">复制</div>
            </div>
            <div class="famous-comment-more-bottom-bar" @click="clickCancel">取消</div>
        </van-popup>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils';
export default {
    name: 'FamousCommentMore',
    computed: {
        showPediaCommentMore() {
            return this.$store.state.famouspediacomment.showPediaCommentMore;
        },
        curCommentMoreData() {
            return this.$store.state.famouspediacomment.curCommentMoreData;
        },
        curCommentMoreFromMe() {
            return this.$store.state.famouspediacomment.curCommentMoreFromMe;
        }
    },
    methods: {
        clickPopOverlay() {
            this.$store.state.famouspediacomment.showPediaCommentMore = false;
        },
        clickDelete() {
            var me = this;
            this.$store.dispatch('famouspediacomment/deleteComment', {
                cb: function() {
                    me.$toast('删除评论成功');
                },
                failCb: function() {
                    me.$toast('删除评论失败');
                }
            })
        },
        clickReport() {
            this.$store.state.famouspediacomment.showPediaCommentMore = false;
            this.$store.state.famouspediacomment.showPediaCommentReport = true;
        },
        clickCopy() {
            console.log('clickCopy', this.curCommentMoreData.msg)
            var me = this;
            UTILS.copyTextToClipboard(this.curCommentMoreData.msg, function() {
                me.$store.state.famouspediacomment.showPediaCommentMore = false;
                me.$toast('复制评论内容成功');
            })
        },
        clickCancel() {
            this.$store.state.famouspediacomment.showPediaCommentMore = false;
        }
    }
}
</script>